'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const STORAGE_KEY = 'analytics:anon-id';

function getAnonId() {
  if (typeof window === 'undefined') return null;

  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;

    const generated = crypto.randomUUID();
    window.localStorage.setItem(STORAGE_KEY, generated);
    return generated;
  } catch {
    return null;
  }
}

function sendTrack(pathname: string, anonId: string | null) {
  const payload = JSON.stringify({ pathname, anonId });

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([payload], { type: 'application/json' });
    navigator.sendBeacon('/api/analytics/track', blob);
    return;
  }

  void fetch('/api/analytics/track', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: payload,
    cache: 'no-store',
    keepalive: true,
  });
}

export function ClientAnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    // Минимальная защита от headless-автоматики/скриптов.
    if (typeof navigator !== 'undefined' && navigator.webdriver) return;

    sendTrack(pathname, getAnonId());
  }, [pathname]);

  return null;
}
